import detectIos from '../utils/detect-ios';

export default () => {
  if (detectIos()) {
    document.body.classList.add('is-ios');
    // console.log('----- is ios');
  } else {
    // console.log('----- not ios');
  }
};
